import { Directive, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MenuItem } from "primeng/api";
import { ConfigurationType, ControlType, FormPage, TypeChecker } from "../../../shared";
import { FormCreatorService } from "../../../services";

@Directive()
export class BaseFormViewer{
  @Input() onSubmitForm ?: (data: string) => void;

  configurationType = ConfigurationType
  controlType = ControlType;
  typeChecker = TypeChecker;

  readonly isDesigner = false;

  constructor(public fc: FormCreatorService) { 
    
  }

  get pageItems(): MenuItem[] {
    return this.fc.Pages.map((page) => {
      return { label: page.title } as MenuItem;
    });
  }

  get isFirstPage(){
    return this.fc.activeIndex == 0;
  }

  get isLastPage(){
    return this.fc.activeIndex == this.fc.Pages.length - 1;
  }

  nextPage() {
    if(!this.fc.activePage || this.isLastPage) return;
    if(!this.fc.viewAnswerMode){
      this.fc.Pages[this.fc.activeIndex].submitted = true;
      const pageGroup = this.fc.getPageFormGroup(this.fc.activePage.name);
      if(!pageGroup.valid) return;
    }
    this.fc.activeIndex++;                        
  }

  prevPage() {
    if(this.isFirstPage) return;
    this.fc.activeIndex--;
  }

}